import dayjs from "dayjs";
import { swSettings } from "app/common/services/swSettings";
import DurationService from "app/services/DurationService";
import { proNavigator } from "single-spa/react-app/ProNavigator";

const UNIT = "days";

export const getIsPeriodOverPeriodChangeAvailable = () => {
    const params = proNavigator.getParams();
    const { duration } = params;
    const durationData = DurationService.getDurationData(duration);
    const { to, from } = durationData.raw;
    const snapshotIntervalStartDate = dayjs.utc(swSettings.current.resources.SnapshotInterval.startdate);
    const isPeriodOverPeriodChangeAvailable = from.isAfter(snapshotIntervalStartDate.add(to.diff(from, UNIT), UNIT));
    return isPeriodOverPeriodChangeAvailable;
};
